import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CategoryComponent } from './components/category/category.component';
import { AdminComponent } from './admin.component';
import { TasksComponent } from './components/tasks/tasks.component';
import { RestaurantComponent } from './components/restaurant/restaurant.component';
import { ItemComponent } from './components/item/item.component';

const routes: Routes = [
  {
    path: '',
    component: AdminComponent,
    children: [
      {
        path: 'category',
        component: CategoryComponent,
      },
      {
        path: 'tasks',
        component: TasksComponent,
      },
      {
        path: 'restaurants',
        component: RestaurantComponent,
      },
      {
        path: 'item',
        component: ItemComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminRoutingModule {}
